import React, { useState, useEffect } from 'react';
import { getLang, setLang } from '@/locales';

export default function LangSwitch() {
  const [lang, setLangState] = useState(getLang());

  useEffect(() => {
    const handleChange = () => {
      setLangState(getLang());
    };
    window.addEventListener('langChange', handleChange);
    return () => window.removeEventListener('langChange', handleChange);
  }, []);

  const toggleLang = () => {
    const newLang = lang === 'en' ? 'zh' : 'en';
    setLang(newLang);
    //window.location.reload();
  };

  return (
    <button
      onClick={toggleLang}
      className="text-white lg:text-lg text-sm font-bold border-2 border-white/50 rounded-full lg:px-5 px-3 lg:py-2 py-1 cursor-pointer bg-white/10 hover:bg-white/20 transition-colors tracking-wider"
    >
      <span className={lang === 'zh' ? 'text-gold' : 'opacity-60'}>中文</span>
      <span className="mx-1.5 opacity-40">/</span>
      <span className={lang === 'en' ? 'text-gold' : 'opacity-60'}>EN</span>
    </button>
  );
}
